import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CalendarEvent } from 'angular-calendar';
import { colors } from './colors';
import { Subject } from 'rxjs/Subject';
import { CalendarHeaderComponent } from './calender-header.component';


@Component({
  selector: 'mwl-demo-component',
  templateUrl: './calender.component.html'
//styleUrls: ['./app.component.css']
})
export class CalenderComponent {

  view: string = 'month';

    viewDate: Date = new Date();

    events: CalendarEvent[] = [];

    refresh: Subject<any> = new Subject();

    addEvent(date: Date): void {
      this.events.push({
        start: date,
        title: 'New event',
        color: colors.red

      });
      this.refresh.next();
    }

}



// WEBPACK FOOTER //
// /Library/WebServer/Documents/task-manager/src/app/calender.component.ts